<template>
  <div class="container-24 section-to-print print-only" >
    <div id="print-billing-sessions" class="container billing-container">

      <div class="row">
        <div class="col-md-12">
          <print-header
            :breadcrumb="previousView === 'makeAPayment' ? 'My Billing > Make a Payment' : 'My Billing > Manage AutoPay'"
            :titleHeader="confirmTitle"></print-header>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="datas-print">
            <span class="label-print">Date:</span>
            <span class="data-print">{{moment().format('MM/DD/YYYY')}}</span>
          </div>

          <div class="datas-print" v-if="paymentData.agreements && paymentData.agreements.length > 0">
            <span class="label-print">Amount Paid:</span>
            <span class="data-print">${{amountPaid}}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div v-bind:class="paymentData.agreements && paymentData.agreements.length > 0 ? 'datas-print' : 'datas-print-no-limit-width'">
            <span class="label-print">Description:</span>
            <span class="data-print">{{confirmDescription}}</span>
          </div>
          <div class="datas-print" v-if="paymentData.agreements && paymentData.agreements.length > 0">
            <span class="label-print">Billed To:</span>
            <span class="data-print">
              <template v-if="cardType === 'MC'">
                <i class="fa fa-cc-mastercard fa-lg"></i>
                MasterCard
              </template>
              <template v-else-if="cardType === 'VISA'">
                <i class="fa fa-cc-visa fa-lg"></i>
                Visa
              </template>
              <template v-else-if="cardType === 'AMX'">
                <i class="fa fa-cc-amex fa-lg"></i>
                American Express
              </template>
              <template v-else-if="cardType === 'DIS'">
                <i class="fa fa-cc-discover fa-lg"></i>
                Discover
              </template>
              <template v-else>
                <i class="fa fa-university fa-lg"></i>
              </template>
            </span>
          </div>
        </div>
      </div>

      <hr>
      <div class="row">
        <div class="col-md-12">
          <div class="info">
            <p>Please allow 24 hours for your agreement(s) records to be updated. You will also receive a confirmation email of this request you have submitted online.</p>
          </div>
        </div>
      </div>

      <div class="row print-table" v-if="paymentData.agreements && paymentData.agreements.length > 0">
        <table class="col-md-12 table-main">
          <tr>
            <td class="table-data">
              <table class="table">
                <thead>
                  <tr>
                    <th class="title-cells" >Member</th>
                    <th class="title-cells text-center" >Agreement</th>
                    <th class="title-cells text-center" >Reference Number</th>
                    <th class="title-cells text-center" >Description</th>
                    <th class="title-cells text-center" >Amount Paid</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="row in paymentData.agreements" >
                  <td> {{ row.memberName }} </td>
                  <td class="text-center">
                    <span class="data-item">{{ row.agreement}}</span>
                    <br>
                    <span class="data-item">{{ '(' + row.agreementDescription + ')' }}</span>
                  </td>
                  <td class="text-center"> {{ row.referenceNumber }} </td>
                  <td class="text-center"> {{ row.description }} </td>
                  <td class="text-center"> {{ row.balance.toFixed(2) }} </td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr><!---end of row  -->
        </table>
      </div>

      <div v-if="paymentData.selectedEftAgreements.length">
        <div class="row">
          <div class="col-md-12">
            <div class="info">
              <p>Your request to update the billing information for monthly dues has been submitted. The following amount(s) (plus applicable tax) will be charged to your account through the ACH, (each an”EFT”), or recurring charges to your credit card (“RCC”), on your next bill date.</p>
            </div>
          </div>
        </div>

        <div class="row print-table">
          <table class="col-md-12 table-main">
            <tr>
              <td class="table-data">
                <table class="table">
                  <thead>
                  <tr>
                    <th class="title-cells" >Member</th>
                    <th class="title-cells text-center" >Agreement</th>
                    <th class="title-cells text-center" >Next Debit Date</th>
                    <th class="title-cells text-center" >Method of Payment</th>
                    <th class="title-cells text-center" >Dues Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in eftAgreements" >
                    <td>{{ row.memberName }}</td>

                    <td class="text-center">
                      <span class="data-item">{{ row.agreementId }}</span>
                      <br>
                      <span class="data-item">{{'(' + row.agreementType + ')' }}</span>
                    </td>

                    <td class="text-center">
                      <span class="data-item">{{ row.renewal }}</span>
                    </td>

                    <td class="text-center">
                      <template v-if="row.accountType === 'MC'">
                        <i class="fa fa-cc-mastercard fa-lg"
                           :class="{'overdue-card' : moment(row.cardExpirationDate, 'MM/YY') < moment()}"></i>
                      </template>
                      <template v-else-if="row.accountType === 'VISA'">
                        <i class="fa fa-cc-visa fa-lg"
                           :class="{'overdue-card' : moment(row.cardExpirationDate, 'MM/YY') < moment()}"></i>
                      </template>
                      <template v-else-if="row.accountType === 'AMX'">
                        <i class="fa fa-cc-amex fa-lg"
                           :class="{'overdue-card' : moment(row.cardExpirationDate, 'MM/YY') < moment()}"></i>
                      </template>
                      <template v-else-if="row.accountType === 'DIS'">
                        <i class="fa fa-cc-discover fa-lg"
                           :class="{'overdue-card' : moment(row.cardExpirationDate, 'MM/YY') < moment()}"></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-university fa-lg"></i>
                      </template>
                      <br>
                      <span class="data-item" :class="{'overdue-card' :
            !(row.accountType === 'SAV' || row.accountType === 'CHK')
            && moment(row.cardExpirationDate, 'MM/YY') < moment()}">
              {{ row.autoBilled }}
                    </span>
                      <br>
                      <template v-if="row.cardExpirationDate">
                <span class="data-item"
                      :class="{'overdue-card' : moment(row.cardExpirationDate, 'MM/YY') < moment()}">(Exp. {{row.cardExpirationDate}})</span>
                      </template>
                    </td>

                    <td class="text-center" data-title='Dues Amount'>
                    <span class="data-item">
                      {{ '$' + row.recurringDues.toFixed(2) }}
                    </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
        </div>

        <div class="row">
          <div class="col-md-12">
            NOTE: Requests to update your billing information made within 5 days of your next debit date may not take effect until the following month.
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <hr class="bg-gray">
          </div>
        </div>

        <div class="row">
          <div class="terms-and-conditions col-md-12">
            <div class="tac-title">
              <i class="fa fa-file-text-o" aria-hidden="true"></i> <span class="margin-sides-10">Terms and Conditions</span>
            </div>
            <hr>
            <div v-html="htmlTac"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { StringUtils } from 'my-account-common'
  import { AlertBanner } from 'my-account-common-vue'
  import printHeader from './PrintHeader.vue'

  export default {
    name: 'paymentconfirmation',
    data () {
      return {
        moment: moment
      }
    },
    methods: {
      getOrdinal (nextPayment) {
        if (nextPayment > 3 && nextPayment < 21) return nextPayment + 'th'
        switch (nextPayment % 10) {
          case 1: return nextPayment + 'st'
          case 2: return nextPayment + 'nd'
          case 3: return nextPayment + 'rd'
          default: return nextPayment + 'th'
        }
      }
    },
    mounted () { },
    computed: {
      eftAgreements: {
        get: function () {
          if (!this.paymentData.eftAgreements.firstName) {
            return []
          }
          let masterAgreement = _.map(this.paymentData.eftAgreements.agreementEFTs, (agreement) => {
            const agreementData = _.cloneDeep(agreement)
            agreementData.memberName = StringUtils.initCaps(this.paymentData.eftAgreements.firstName + ' ' + this.paymentData.eftAgreements.lastName)
            agreementData.mainUser = true
            agreementData.autoBilled = 'x-' + this.paymentData.bankInformation.cardNumber
            agreementData.renewal = this.getOrdinal(new Date(agreement.renewal).getDate())
            agreementData.accountType = this.paymentData.bankInformation.cardType
            agreementData.cardExpirationDate = this.paymentData.bankInformation.cardExpirationDate
            agreementData.selected = false
            return agreementData
          })
          let faoAgreements = _.map(this.paymentData.eftAgreements.memberFaos, (owner) => {
            return _.map(owner.agreementEFTs, (agreement) => {
              const agreementData = _.cloneDeep(agreement)
              agreementData.memberName = StringUtils.initCaps(owner.firstName + ' ' + owner.lastName)
              agreementData.mainUser = false
              agreementData.autoBilled = 'x-' + this.paymentData.bankInformation.cardNumber
              agreementData.renewal = this.getOrdinal(new Date(agreement.renewal).getDate())
              agreementData.accountType = this.paymentData.bankInformation.cardType
              agreementData.cardExpirationDate = this.paymentData.bankInformation.cardExpirationDate
              agreementData.selected = false
              return agreementData
            })
          })
          let mappedAgreements = masterAgreement.concat([].concat.apply([], faoAgreements))
          return _.filter(mappedAgreements, (agreement) => _.includes(this.paymentData.selectedEftAgreements, agreement.agreementId))
        }
      }
    },
    props: {
      paymentData: {
        type: Object,
        default: {}
      },
      amountPaid: {
        type: String,
        default: ''
      },
      confirmTitle: {
        type: String,
        required: true
      },
      confirmDescription: {
        type: String,
        default: ''
      },
      cardType: {
        type: String,
        default: ''
      },
      htmlTac: {
        type: String,
        default: ''
      },
      previousView: {
        type: String,
        requited: true
      }
    },
    components: {
      'alert-banner': AlertBanner,
      'print-header': printHeader
    }
  }
</script>

<style lang="scss">
  @import '~CommonBilling/css/variables';

  #print-billing-sessions {
    display: none;
  }

  @media print {
    #print-billing-sessions {
      display: block;
    }
    #footer-24 {
      display: none!important;
    }
  }

  .bg-gray {
    background-color: #cccccc;
  }

  .title-cells {
    font-weight: bold;
  }

  .datas-print {
    display: inline-block;
    width: 240px;
    margin-bottom:20px;

    .label-print {
      font-weight: bold;
      display: inline-block;
    }

    .data-print {
      padding: 5px 0;

      i {
        padding: 0 5px;
      }
    }
  }

  .datas-print-no-limit-width{
    display: inline-block;
    margin-bottom:20px;

    .label-print {
      font-weight: bold;
      display: inline-block;
    }

    .data-print {
      padding: 5px 0;

      i {
        padding: 0 5px;
      }
    }
  }

  .print-table {
    margin-bottom: 20px;
    padding-left: 15px;
    padding-right: 15px;

    .table-main {
      &:last-child {
        border-bottom: 1px solid #ccc;
      }
      width: 100%;
    }
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) { }

  /* Small devices (tablets, 768px and up) */
  @media (min-width: $screen-sm-min) { }

  /* Medium devices (desktops, 992px and up) */
  @media (min-width: $screen-md-min) { }
</style>



// WEBPACK FOOTER //
// node_modules/PaymentConfirmation/PaymentConfirmationPrint.vue